import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function TeamInvitesBanner() {
  const { data } = useQuery({
    queryKey: ["my-team-invitations"],
    queryFn: async () => (await api.get("/team-invites/mine")).data,
  });
  const count = data?.invitations?.length || 0;
  if (!count) return null;
  return (
    <Card className="mt-6 flex items-center gap-4 border-primary/30 bg-primary/5 p-4" data-testid="dashboard-team-invites-banner">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Mail className="h-5 w-5" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-[600] text-foreground">
          You have {count} team invitation{count > 1 ? "s" : ""}
        </div>
        <div className="text-xs text-muted-foreground">Review and accept or decline.</div>
      </div>
      <Button asChild size="sm" data-testid="dashboard-view-invitations">
        <Link to="/dashboard/invitations">Review <ArrowRight className="ml-1 h-4 w-4" /></Link>
      </Button>
    </Card>
  );
}
